import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-department-info',
  templateUrl: './department.info.component.html',
  styleUrls: ['./department.info.component.scss'],
})
export class DepartmentInfoComponent implements OnChanges {
  @Input()
  selectedDepartment: string | undefined;

  constructor() {}

  ngOnChanges(changes: any): void {
    if (changes.selectedDepartment) {
      this.selectedDepartment = changes.selectedDepartment.currentValue;
    }
  }

}
